import { formatNameForDisplay } from 'lib/text-display'
import { DateTime } from 'luxon'

const formatUpcomingSessionDate = (startDateTime, timezone) => {
  const start = DateTime.fromISO(startDateTime).setZone(timezone)
  if (!start.isValid) {
    return {
      month: null,
      day: null,
      time: null,
      humanizedStartDateTime: null,
    }
  }

  return {
    month: start.toFormat('LLL').toUpperCase(),
    day: start.toFormat('d'),
    time: start.toFormat('h:mm a'),
    humanizedStartDateTime: formatDate(startDateTime, timezone),
  }
}

const formatUpcomingSession = session => {
  const sessionStartDateTime = session?.startDateTime

  if (sessionStartDateTime) {
    const timezone = session.coachFacility?.timezone || session.timezone
    const sessionDate = formatUpcomingSessionDate(
      sessionStartDateTime,
      timezone,
    )
    return {
      ...session,
      humanizedStartDateTime: sessionDate.humanizedStartDateTime,
      sessionMonth: sessionDate.month,
      sessionDay: sessionDate.day,
      sessionTime: sessionDate.time,
    }
  }

  return {
    __typename: null,
    humanizedStartDateTime: null,
    sessionMonth: null,
    sessionDay: null,
    sessionTime: null,
    title: null,
    startDateTime: null,
  }
}

const processStudentsData = data => {
  const processedData = []

  data?.forEach(studentData => {
    processedData.push(studentData)
  })

  return processedData
}

const parseStudents = coachingCenterStudents => {
  if (!coachingCenterStudents?.length) return []

  return coachingCenterStudents.map(({ student, facilities, coaches }) => {
    const facilityList = (facilities || []).map(({ id }) => id)

    const futureLessons = (student.enrollments || []).filter(
      ({ lesson }) =>
        lesson &&
        !lesson.isCanceled &&
        DateTime.fromISO(lesson.startDateTime) > DateTime.now(),
    )

    const lessonsAtFacility = futureLessons.filter(({ lesson }) =>
      facilityList.includes(lesson?.coachFacility?.id),
    )
    const lessons = lessonsAtFacility.map(({ lesson }) => lesson)
    const firstSortedLessons = [...lessons].sort((a, b) => {
      const aTime = DateTime.fromISO(a.startDateTime)
      const bTime = DateTime.fromISO(b.startDateTime)
      if (!aTime.isValid && !bTime.isValid) return 0
      if (!aTime.isValid) return 1
      if (!bTime.isValid) return -1
      return aTime.toMillis() - bTime.toMillis()
    })[0]
    const nextSession = formatUpcomingSession(firstSortedLessons)
    return {
      id: student.id,
      firstName: student.firstName,
      lastName: student.lastName,
      fullName: formatNameForDisplay(
        `${student.firstName} ${student.lastName}`,
      ),
      isMinor: student.isMinor,
      upcomingSession: nextSession,
      representatives: student.contact,
      coaches: coaches || [],
      facilities: facilities || [],
    }
  })
}

const formatDate = (startDateTime, timezone) => {
  const newDate = DateTime.fromISO(startDateTime).setZone(timezone)

  return newDate.toFormat('MMM d, yyyy, h:mma')
}

export { parseStudents, processStudentsData, formatDate }
